import type { HealthcheckResult } from '../api/proxies';

export type HealthcheckStepState = 'ok' | 'warn' | 'fail' | 'skipped';

export interface HealthcheckStepView {
  key: string;
  title: string;
  state: HealthcheckStepState;
  ms?: number;
  detail?: string;
}

const STEP_TITLES: Array<[string, string]> = [
  ['tcp_connect', '连接节点代理端口'],
  ['socks5_handshake', 'SOCKS5 账号认证'],
  ['socks5_connect', '代理转发到目标站点'],
  ['ip_geo_detect', '检测出口 IP 与归属地'],
];

// Turns a healthcheck response into the fixed four-stage list shown in the
// progress dialog. The first stage the probe never completed is the failing
// one; everything after it is skipped.
export const buildHealthcheckSteps = (result: HealthcheckResult): HealthcheckStepView[] => {
  const done = new Map((result.steps || []).map((s) => [s.step, s.ms]));
  let failed = false;
  return STEP_TITLES.map(([key, title]) => {
    const ms = done.get(key);
    if (failed) return { key, title, state: 'skipped' as const };
    if (ms === undefined) {
      failed = true;
      return { key, title, state: 'fail' as const, detail: result.error || '未完成' };
    }
    if (key === 'socks5_connect') {
      return { key, title, state: 'ok' as const, ms, detail: result.target };
    }
    if (key === 'ip_geo_detect') {
      if (!result.ipv4_check_ok) {
        const ip = result.detected_ipv4 ? `出口 IP ${result.detected_ipv4}；` : '';
        return { key, title, state: 'warn' as const, ms, detail: `${ip}${result.ipv4_error || '检测失败'}` };
      }
      return {
        key,
        title,
        state: 'ok' as const,
        ms,
        detail: `${result.detected_ipv4 || '—'} · ${result.ip_location || '未知'}${result.ip_source === 'node' ? '（节点地址；机房拦截了回显，未经代理实测）' : ''}`,
      };
    }
    return { key, title, state: 'ok' as const, ms };
  });
};
